module.exports = __webpack_public_path__ + "static/media/operational2.bc6b7fdb.png";